import { transit } from "react-css-transition"

export default {
  defaultStyle: {
    opacity: 0,
    transform: transit("translate(0, -20px)", 300, "ease-in-out"),
  },
  enterStyle: {
    opacity: transit(1.0, 500, "ease-in-out"),
    transform: transit("translate(0, 0)", 300, "ease-in-out"),
  },
  leaveStyle: {
    opacity: transit(0, 500, "ease-in-out"),
    transform: transit("translate(0, -20px)", 300, "ease-in-out"),
  },
  // activeStyle: {
  //   opacity: 1.0,
  //   transform: "translate(0, 0)"
  // }
}